import React, { useCallback, useEffect, useState } from "react";
import * as _ from "lodash"
import { Button, Table } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";

// icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore } from "@fortawesome/free-solid-svg-icons";

// constants
import { GET_POST_COMMENTS } from "../../../graphql/postComment/query";
import CreateOrderModal from "./CreateOrderModal";
import PaginationsV1 from "../../../components/PaginationV1";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { K_LOCAL_STORAGE_SHOP_SETTING_DATA } from "../../../constants";
import CreateOrderModalV2 from "./CreateOrderModalV2";

function LiveDetailMessage({ liveData, postStocks, setPostStocks, getOrderData, liveSreenType }) {

    const [liveComments, setLiveComments] = useState([]);
    const [showCreateOrderModal, setShowCreateOrderModal] = useState(false);
    const [selectedComment, setSelectedComment] = useState();
    const [totalComment, setTotalComment] = useState(0);
    const settingByShopData = JSON.parse(localStorage.getItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA));

    // apollo client hooks
    const [getLiveComments, { data: liveCommentsData, loading: liveCommentsLoading }] = useLazyQuery(GET_POST_COMMENTS, { fetchPolicy: "cache-and-network" });

    // control pagination
    const rowsPerPage = 50;
    const [page, setPage] = useState(0);
    const pageAll = totalComment > 0 ? Math.ceil(totalComment / rowsPerPage) : 1;
    const handleChangePage = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    // useEffect Hooks
    useEffect(() => {
        handleFetchComment()
    }, [page, liveData])

    useEffect(() => {
        if (liveCommentsData?.postComments) {
            setLiveComments(liveCommentsData?.postComments?.data)
            setTotalComment(liveCommentsData?.postComments?.total)
        }
    }, [liveCommentsData])


    // fetch comments alls
    const handleFetchComment = async () => {
        await getLiveComments({
            variables: {
                where: {
                    post: liveData?.id
                },
                limit: rowsPerPage,
                skip: page * rowsPerPage,
                orderBy: "createdAt_DESC"
            }
        })
    }

    // check loading is data or not data
    if (liveCommentsLoading && !liveCommentsData) return <LoadingSpinner />
    
    return (
        <div>
            <div className="py-2">
                <p style={{ fontSize: 20}}>ລາຍການຄອມເມັ້ນ</p>
            </div>
            <div>
                <Table responsive className="staff-table-list borderless table-hover">
                    <thead style={{ background: "#F1F1F1" }}>
                        <tr>
                            <th style={{ borderBottom: "none" }}>ລຳດັບ</th>
                            <th style={{ borderBottom: "none" }}>ຊື່ລູກຄ້າ</th>
                            <th style={{ borderBottom: "none" }}>ຄອມເມັ້ນ</th>
                            <th style={{ borderBottom: "none", textAlign: 'center' }}>ສະຖານະ</th>
                            <th style={{ borderBottom: "none" }}>ວັນທີ,ເດືອນ,ປີ</th>
                            <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {liveComments?.map((comment, index) => (
                            <tr key={index} style={{ whiteSpace: 'nowrap' }}>
                                <td>{page * rowsPerPage + index + 1}</td>
                                <td>{comment?.name ?? ""}</td>
                                <td style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{comment?.message ?? ""}</td>
                                <td style={{ textAlign: 'center' }}><span style={{
                                    padding: 10,
                                    borderRadius: 8, fontSize: 12,
                                    border: '1px solid ' + (!comment?.isCreated ? "red" : "green"),
                                    color: !comment?.isCreated ? "red" : "green"
                                }}>{!comment?.isCreated ? "ຍັງບໍ່ໄດ້ສ້າງອໍເດີ້" : "ອໍເດີ້ສໍາເລັດ"}</span></td>
                                <td>{moment(comment?.createdAt).format('DD/MM/YYYY HH:mm A')}</td>
                                <td>
                                    <div>
                                        <Button disabled={comment?.isCreated ? true : false} style={{ borderRadius: 6, borderColor: "#5357B6", color: "#5357B6", padding: 2, background: 'transparent' }}
                                            onClick={() => {
                                                setShowCreateOrderModal(true);
                                                setSelectedComment(comment)
                                            }}>
                                            <FontAwesomeIcon icon={faStore} className="mr-2" />ສ້າງອໍເດີ້
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <div style={{ overflowX: "auto", paddingLeft: '4em' }}>
                    <PaginationsV1
                        count={totalComment}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        pageAll={pageAll}
                        onPageChange={handleChangePage}
                        textNext=">"
                        textPrev="<"
                    />
                </div>
            </div>
            {
                !settingByShopData?.multipleOdFrmCm  || !settingByShopData ? 
                (
                    <CreateOrderModal
                        liveId={liveData?.id}
                        showCreateOrderModal={showCreateOrderModal}
                        setShowCreateOrderModal={setShowCreateOrderModal}
                        postStocks={postStocks}
                        setPostStocks={setPostStocks}
                        selectedComment={selectedComment}
                        liveComments={liveComments}
                        setLiveComments={setLiveComments}
                        getOrderData={getOrderData}
                        liveSreenType={liveSreenType}
                    />
                ) : (
                    //TODO For create order v2
                    <CreateOrderModalV2
                        liveId={liveData?.id}
                        showCreateOrderModal={showCreateOrderModal}
                        setShowCreateOrderModal={setShowCreateOrderModal}
                        postStocks={postStocks}
                        setPostStocks={setPostStocks}
                        selectedComment={selectedComment}
                        liveComments={liveComments}
                        setLiveComments={setLiveComments}
                        getOrderData={getOrderData}
                        liveSreenType={liveSreenType}
                    /> 
                )
            }
        </div >
    );
}

export default LiveDetailMessage;